import { DEFAULT_EXCEL_HEADER } from "./constants";
import { rowToExcelArray } from "./rowUtils";

export function exportRowsToExcel(rows, filename = "동원자원_훈련결과.xlsx") {
  const XLSX = require("xlsx");
  const data = [
    DEFAULT_EXCEL_HEADER,
    ...rows.map((row) => rowToExcelArray(row)),
  ];
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, filename);
}
